import React, { useState } from 'react'
import * as R from 'ramda'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { Typography } from '@material-ui/core'

import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'
import TextLinkToDialogButton from 'app/components/buttons/TextLinkToDialogButton'

import { usePlanBillingContext } from '../usePlanBillingContext'
import PlanBillingDetailsFormDialog from './PlanBillingDetailsFormDialog'

export const PlanBillingShipping = ({ shippingAddress, onSubmit }) => {
  const { refetch } = usePlanBillingContext()
  const { formatMessage } = useIntl()
  const reduxDispatch = useDispatch()
  const [isOpenBillingDetailsDialog, setIsOpenBillingDetailsDialog] =
    useState(false)

  const handleSubmitBillingDetails = async (data) => {
    try {
      await effects.apis.updateBillingShippingAddress(
        R.mergeRight(shippingAddress, data),
      )
      onSubmit()
      refetch()
      setIsOpenBillingDetailsDialog(false)
    } catch (error) {
      reduxDispatch(MessageAlert.showNetworkError(formatMessage)(error))
    }
  }

  return (
    <>
      <Typography>
        {/* <FormattedMessage
              id="Update Shipping Address"
              values={{
                b1: text => (
                  <TextLinkToDialogButton
                    onClick={() => {}}
                    className={clsx('cursor-pointer')}
                    text={text}
                  />
                ),
              }}
            /> */}
        <TextLinkToDialogButton
          onClick={() => setIsOpenBillingDetailsDialog(true)}
          className="cursor-pointer"
          text={'Update Shipping Address'}
        />
      </Typography>
      <PlanBillingDetailsFormDialog
        titleId="planAndBilling.shippingDetails.form.title.label"
        initialValue={shippingAddress}
        isOpen={isOpenBillingDetailsDialog}
        onClose={() => setIsOpenBillingDetailsDialog(false)}
        onSubmit={handleSubmitBillingDetails}
      />
    </>
  )
}
